import {EzButton, EzLink} from '@ezcater/recipe';
import styled from '@emotion/styled';
import {useTranslation} from 'react-i18next';
import PhoneNumbers from 'constants/PhoneNumbers';

const DialogOverlay = styled('div')`
  margin: 50px auto 0 auto;
  max-width: 500px;
  width: 100%;
  background-color: #fff;
  color: #666;
  text-align: center;
  font-family: 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial,
    'Lucida Grande', sans-serif;
  font-size: 20px;
`;

const Dialog = styled('div')`
  margin: 15px;
  padding: 40px;
  border: 1px solid #ccc;
  border-radius: 12px;
  -moz-border-radius: 12px;
  -webkit-border-radius: 12px;
`;

const LogoLink = styled('a')`
  display: inline-block;

  img {
    height: auto;
    width: 100%;
    max-width: 238px;
  }
`;

const Heading = styled('h1')`
  color: #369;
`;

const DialogContent = styled('div')`
  a {
    white-space: nowrap;
  }

  > * + * {
    margin-top: 16px;
  }
`;

const hardRefreshPage = (): void => {
  if (typeof window !== 'undefined') window.location.reload();
};

const ErrorDialog = () => {
  const {t} = useTranslation();

  return (
    <DialogOverlay>
      <Dialog>
        <LogoLink href="https://www.ezcter.com">
          <img
            alt="ezCater logo"
            src="/static/images/brand/logo-dark.png"
            height="56"
            width="238"
          />
        </LogoLink>
        <Heading>{t('generalError.header')}</Heading>
        <DialogContent>
          <p>{t('generalError.dialogMessage.line1')}</p>
          <p>
            {t('generalError.dialogMessage.line2')}{' '}
            <EzLink href={`tel:${PhoneNumbers.EZDISPATCH_DIRECT}`}>
              {PhoneNumbers.EZDISPATCH_DIRECT}
            </EzLink>
            .
          </p>
          <EzButton onClick={hardRefreshPage}>{t('generalError.reloadButtonLabel')}</EzButton>
        </DialogContent>
      </Dialog>
    </DialogOverlay>
  );
};

export default ErrorDialog;
